import { useMemo } from "react"

import { BookingStatusMap } from "utils/interfaces"
import { usePaymentContext } from "modules/Payment/PaymentContext"
import { HeadingContainer, HeadingEmojiWithText, PsyAvatar } from "modules/BookingCommon/components"

export function Heading() {
    const [
        {
            bookingDetails: { psy },
            bookingStatus,
        },
    ] = usePaymentContext()

    const title = useMemo(() => {
        if (bookingStatus === BookingStatusMap.PAID) {
            return <HeadingEmojiWithText text="Вы записались к психологу" />
        }

        if (
            bookingStatus === BookingStatusMap.CANCELLED ||
            bookingStatus === BookingStatusMap.CANCELLED_AFTER_PAYMENT ||
            bookingStatus === BookingStatusMap.PAID_AFTER_CANCELLATION ||
            bookingStatus === BookingStatusMap.CANCELLED_WITHOUT_REFUND
        ) {
            return <div className="booking-heading-text">Управление сессией</div>
        }

        return (
            <>
                <PsyAvatar psy={psy} />
                <div className="booking-heading-text">Оплатите сессию</div>
            </>
        )
    }, [bookingStatus, psy])

    return <HeadingContainer>{title}</HeadingContainer>
}
